declare global {
  interface Window {
    __CURECALL_CONFIG__?: {
      API_URL?: string
      API_WS?: string
      BACKOFFICE_URL?: string
      PATIENT_APP_URL?: string
      ENVIRONMENT?: string
      ZENDESK_KEY?: string
      IS_CURECALL_MESSENGER_ACTIVATED?: boolean
    }
  }
}

export const config = {
  API_URL: window.__CURECALL_CONFIG__?.API_URL ?? import.meta.env.VITE_API_URL ?? '',
  API_WS: window.__CURECALL_CONFIG__?.API_WS ?? import.meta.env.VITE_API_WS ?? '',
  BACKOFFICE_URL: window.__CURECALL_CONFIG__?.BACKOFFICE_URL ?? import.meta.env.VITE_BACKOFFICE_URL ?? '',
  PATIENT_APP_URL: window.__CURECALL_CONFIG__?.PATIENT_APP_URL ?? import.meta.env.VITE_PATIENT_APP_URL ?? '',
  ENVIRONMENT: window.__CURECALL_CONFIG__?.ENVIRONMENT ?? import.meta.env.VITE_ENVIRONMENT ?? '',
  ZENDESK_KEY: window.__CURECALL_CONFIG__?.ZENDESK_KEY ?? import.meta.env.VITE_ZENDESK_KEY ?? '',
  IS_CURECALL_MESSENGER_ACTIVATED:
    window.__CURECALL_CONFIG__?.IS_CURECALL_MESSENGER_ACTIVATED ??
    import.meta.env.VITE_IS_CURECALL_MESSENGER_ACTIVATED === 'true',
}
